import React from 'react'
import PropTypes from 'prop-types'
import Toggle from 'material-ui/Toggle'

const styles = {
  activeContainer: {
    margin: '0 auto',
  },
  heading: {
    marginBottom: '10px',
    textAlign: 'center',
  },
  toggleContainer: {
    width: '130px',
    margin: '0 auto',
    textAlign: 'left',
  },
}

const ActiveSettings = ({
  emailsActive,
  handleActiveToggle,
  textsActive,
  tier,
}) => {
  const toggle = (messageType) => {
    const typeBool = messageType === 'email' ? emailsActive : textsActive
    handleActiveToggle(messageType, !typeBool)
  }
  const showTexts = tier !== 4
  return (
    <div style={styles.activeContainer}>
      <div style={styles.heading}>Active Settings</div>
      <div style={styles.toggleContainer}>
        <Toggle
          id="emailsActiveToggle"
          toggled={emailsActive}
          label="Emails"
          onToggle={() => toggle('email')}
        />
        {showTexts && (
          <Toggle
            id="textsActiveToggle"
            toggled={textsActive}
            label="Texts"
            onToggle={() => toggle('text')}
          />
        )}
      </div>
    </div>
  )
}

ActiveSettings.propTypes = {
  emailsActive: PropTypes.bool.isRequired,
  handleActiveToggle: PropTypes.func.isRequired,
  textsActive: PropTypes.bool.isRequired,
  tier: PropTypes.number.isRequired,
}

export default ActiveSettings



// WEBPACK FOOTER //
// ./src/components/Settings/PostApptReviewMessageEditor/ActiveSettings.js